
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { GlobalService } from '../../../services/global.service';
import { SharedActions } from '../actions/index';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class AccessRequestRejectEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions$: Actions,
        private readonly apiService: ApiService,
        private globalService: GlobalService,
    ) { }

    RejectAccessRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SharedActions.rejectAccessRequest),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.updateAccessRequests(action).pipe(
                    map(() => {
                        this.globalService.loadingSubject.next(false);
                        return SharedActions.rejectAccessRequestSuccess();
                    }),
                    catchError((error) => {
                        this.globalService.loadingSubject.next(false);
                        return of(SharedActions.rejectAccessRequestFail({ payload: tryNormalizeHttpError(error, this.logger) }));
                    })
                );
            })
        )
    );

}